<template>
  <div class="vkb_nak vkb_nak_vkb vkb_nak_generationendepot">
    <div ref="heading" name="heading" class="large-12 columns">
      <div class="row">
        <div class="large-12 columns">
          <div class="row">
            <div :class="['small-12 medium-12 large-12 columns']">
              <form>
                <!-- <h2>Rechnen Sie mit mehr</h2>
                <p class="paragraphs">
                  Berechnen Sie beispielhaft, wie sich Ihr Vermögen im GenerationenDepot Invest entwickeln kann.<br>Mit uns treffen Sie die richtige Entscheidung. Wir beraten Sie gerne.
                </p> -->
                <!-- <div class="hide-all show-large show-medium vkb-nak-slider-wrapper">
                  <nSliderVKB :decimals="0" :validvalues="validPremiumValues" :value="form.single_premium" :min="20000" :max="1000000" :side="220" circular tooltip suffix="€" @input="setPremiumValueFromSlider" />
                </div> -->
                <div class="row-input top-space">
                  <label>
                    <i class="fo fo-exclamation info-tooltip">
                      <span class="hint">{{ tooltip.age }}</span>
                    </i>
                    Ich bin
                    <input-number :value="form.age" :input-event="(e) => setAge(e.target.value)"/>
                    Jahre alt.
                  </label>
                  <div v-if="$v.$invalid" class="hint-wrapper">
                    <div v-if="!form.age" class="hint info open">
                      <p>{{ errorMessages.age.required }}</p>
                    </div>
                    <div v-else-if="!$v.form.age.between" class="hint error open">
                      <p>{{ errorMessages.age.between }}</p>
                    </div>
                  </div>
                </div>
                <div class="row-input">
                  <label>
                    <i class="fo fo-exclamation info-tooltip">
                      <span class="hint">{{ tooltip.single_premium }}</span>
                    </i>
                    Ich möchte einmalig
                    <!-- <div class="hide-all show-large show-medium"> -->
                    <div class="select-wrapper">
                      <select :value="form.single_premium" @change="setPremiumValue">
                        <option v-for="item in premiumItems" :value="item.value" :key="item.value">{{ item.text }}</option>
                      </select>
                    </div>
                    <!-- </div> -->
                    <!-- <div class="hide-all show-small">
                      <input :value="formatMoney(form.single_premium)" type="text" class="disabled" readonly="true" @click="showModal=true">
                    </div> -->
                    € einzahlen.
                  </label>
                </div>
                <div class="row-input">
                  <label>
                    <i class="fo fo-exclamation info-tooltip">
                      <span class="hint">{{ tooltip.destination_age }}</span>
                    </i>
                    Ich möchte wissen, wie hoch die Kapitalleistung mit
                    <div class="select-wrapper">
                      <select :value="form.destination_age" @change="setDestinationAge">
                        <option v-for="dest_age in destinationAges" :value="dest_age" :key="dest_age">{{ dest_age }}</option>
                      </select>
                    </div>
                    Jahren ist.
                  </label>
                </div>
                <div class="row-input vkb-nak-input-only-text">
                  <label>
                    <i class="fo fo-exclamation info-tooltip">
                      <span class="hint">{{ tooltip.trend }}</span>
                    </i>
                    Angenommener Kapitalmarktverlauf
                  </label>
                </div>
                <div class="row-input">
                  <div v-for="_trend in trendItems" :key="_trend" class="vkb-nak-radio-wrapper" @click="onSelectTrend(_trend)">
                    <span :class="['vkb-nak-radio-mask', form.trend == _trend ? 'checked' : '']"/>
                    <trend-icons :type="_trend"/>
                    <span class="vkb-nak-radio-label">{{ _trend }}</span>
                  </div>
                </div>
                <div class="row-input">
                  <div class="hide-all show-large show-medium">
                    <a href="#" class="button button-check" @click="expandResult">
                      <span v-if="!showResult">Jetzt berechnen</span>
                      <span v-else>Neu berechnen</span>
                    </a>
                  </div>
                  <div class="hide-all show-small">
                    <a href="#" class="button button-check block" @click="expandResult">
                      <span v-if="!showResult">Jetzt berechnen</span>
                      <span v-else>Neu berechnen</span>
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- <modal v-show="showModal" @close="closeModal">
        <div slot="body">
          <div class="row">
            <div class="row-input columns">
              <label>
                <i class="fo fo-exclamation info-tooltip">
                  <span class="hint">{{ tooltip.single_premium }}</span>
                </i>
                Ich möchte einmalig
                <input :value="formatMoney(form.single_premium)" type="text" class="disabled" readonly="true" @click="showModal=true">
                € einzahlen.
              </label>
            </div>
          </div>
          <div class="vkb-nak-slider-wrapper-modal vkb-nak-slider-wrapper">
            <nSliderVKB :decimals="0" :validvalues="validPremiumValues" :value="form.single_premium" :min="20000" :max="1000000" :side="220" circular tooltip suffix="€" @input="setPremiumValueFromSlider" />
          </div>
        </div>
      </modal> -->

      <div :class="[!showResult ? 'slide-up-reverse' : 'slide-down-reverse', showOverflow && 'show-overflow']">
        <div v-if="showResult" class="slide-block vkb-nak-result-wrapper">
          <div class="row bottom-spacing">
            <div class="small-12 medium-7 large-7 columns tk-vkb-smalltopspace">
              <div class="result-head">
                <h2 class="info-space">
                  <i class="fo fo-exclamation info-tooltip inverted">
                    <span class="hint">{{ tooltip.capital }}</span>
                  </i>
                  Kapitalleistung
                </h2>
              </div>
              <div class="result-table clearfix light">
                <div class="result-row clearfix">
                  <div class="result-cell-description">
                    <p>Auszahlung bei Rückkauf</p>
                  </div>
                  <div class="result-cell-amount light">
                    <p>
                      <span class="h2">€</span>
                      <span class="h2 float-right">{{ formatMoney(result.credit) }}</span>
                    </p>
                  </div>
                </div>
                <div class="result-row clearfix">
                  <div class="result-cell-description">
                    <p>Auszahlung bei Ableben</p>
                  </div>
                  <div class="result-cell-amount dark">
                    <p>
                      <span class="h2">€</span>
                      <span class="h2 float-right">{{ formatMoney(result.fatality) }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="small-12 medium-5 large-5 columns">
              <div class="result-download">
                <a href="#" class="button button-link button-save" @click="getPDF">
                  <i class="fo fo-download"/>
                  <span>Berechnung speichern</span>
                  <i v-if="!!pdfJobId" class="fa fa-spinner fa-spin" />
                </a>
                <div class="hide-all show-large show-medium">
                  <a href="#" class="button button-check call-to-action" @click="onContactClick">
                    <span>Zur Beratung</span>
                  </a>
                </div>
                <div class="hide-all show-small">
                  <a href="#" class="button button-check call-to-action block" @click="onContactClick">
                    <span>Zur Beratung</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logic from './logic.js';

export default {
  name: 'generationendepot_vkb',
  mixins: [logic],
  created() {
    window.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
};
</script>



// WEBPACK FOOTER //
// src/apps/generationendepot/vkb.vue